var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',{staticClass:"mt-2"},[(_vm.divisionDetails.description)?_c('v-div',{staticClass:"mb-4 px-4"},[_c('span',{staticClass:"fs-medium mainFont--text",domProps:{"innerHTML":_vm._s(_vm.formattedDescription)}})]):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }